module.exports = __webpack_public_path__ + "static/media/003-neutral.6dbb0efb.svg";